module.exports = __webpack_public_path__ + "3edf9b94349fb754383480e66c4e3f94.svg";